// Data structure definitions — direct port of C# structs from SPCRJointDynamicsJob.cs
/**
 * Numerical tolerance used by the joint dynamics solver.
 *
 * @public
 */ const EPSILON = 0.001;
/** Constraint topology type */ /**
 * Constraint topology type.
 *
 * @public
 */ var ConstraintType = /*#__PURE__*/ function(ConstraintType) {
    /** Parent-child bone pairs along vertical chains */ ConstraintType[ConstraintType["Structural_Vertical"] = 0] = "Structural_Vertical";
    /** Same-depth bones across adjacent chains */ ConstraintType[ConstraintType["Structural_Horizontal"] = 1] = "Structural_Horizontal";
    /** Diagonal cross-bracing between adjacent chains */ ConstraintType[ConstraintType["Shear"] = 2] = "Shear";
    /** Skip-one vertical (grandparent→grandchild) for bending resistance */ ConstraintType[ConstraintType["Bending_Vertical"] = 3] = "Bending_Vertical";
    /** Skip-one horizontal across chains for bending resistance */ ConstraintType[ConstraintType["Bending_Horizontal"] = 4] = "Bending_Horizontal";
    return ConstraintType;
}({});
/** Collider surface force direction (used for surface/triangle collision) */ /**
 * Collider surface force direction used for surface and triangle collision.
 *
 * @public
 */ var ColliderForce = /*#__PURE__*/ function(ColliderForce) {
    /** No surface force */ ColliderForce[ColliderForce["Off"] = 0] = "Off";
    /** Push surface outward from collider */ ColliderForce[ColliderForce["Push"] = 1] = "Push";
    /** Pull surface inward toward collider */ ColliderForce[ColliderForce["Pull"] = 2] = "Pull";
    return ColliderForce;
}({});

export { ColliderForce, ConstraintType, EPSILON };
//# sourceMappingURL=types.js.map
